import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "../src/assets/main.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./assets/tailwind.css";

const tg = window.Telegram.WebApp;
tg.ready();
tg.expand();
const app = createApp(App);
app.config.globalProperties.$tg = tg;

app.use(router).use(ElementPlus).mount("#app");
